var define = undefined;
var $ = require('jquery');
var vue = require('vue');
var Tether = require('tether');
var qs = require('querystring');
var getShareUrl = require('./getShareUrl');

var ShareButton = vue.extend({
    template: require('./template.hbs')(),
    data() {
        return {
            visible: false
        };
    },
    methods: {
        toggle(e) {
            if (e) {
                e.preventDefault();
            }
            this.visible = this.visible ? false : true;
            this.position();
        },
        position() {
            setTimeout(() => {
                this.tether.position();
            }, 0);
        },
        openShare(provider) {
            var openGraph = `
                ${window.location.protocol + this.baseUrl}/prospector/article/${this.companyId}/${this.slug}?${qs.encode({
                    redirectUrl: location.href
                })}`.trim();
            var url = getShareUrl(provider, openGraph);
            window.open(url, '', `
                menubar=no,
                toolbar=no,
                resizable=yes,
                scrollbars=yes,
                height=600,
                width=600
            `);
            this.toggle();
        }
    },
    ready() {
        this.$menu = $(this.$el);
        this.tether = new Tether({
            element: this.$el,
            target: this.btn,
            attachment: 'top middle',
            targetAttachment: 'bottom middle',
            targetOffset: '5px 0',
            constraints: [{
                to: 'scrollParent',
                attachment: 'together'
            }]
        });
        this.position();
        this._clickHandler = this.toggle.bind(this);
        this.btn.addEventListener('click', this._clickHandler, false);
    },
    destroy() {
        this.btn.removeEventListener('click', this._clickHandler, false);
    }
});

module.exports = ShareButton;



// WEBPACK FOOTER //
// ./src/js/share/index.js